import React from 'react'

const InformationSection = () => {
  return (
    <div className='row'>
      <div className='col-md-6 col-sm-12 col-12 pl-6 pt-6'>
        <h4>About the BIL</h4>
        <p>
          On Nov. 15, 2021, the Infrastructure Investment and Jobs Act, also known as the Bipartisan
          Infrastructure Law, was signed into law. With the passing of the BIL, communities have an
          opportunity to make improvements in roads, bridges, safety, public transit, resilience,
          electric vehicle charging, ports, rail and environmental remediation, as well as increase
          access to clean water, internet and jobs.
        </p>
      </div>

      <div className='col-md-6 col-sm-12 col-12 pt-6'>
        <h4>About the IRA</h4>
        <p>
          On Aug. 16, 2022, the Inflation Reduction Act was signed into law. The IRA provides
          opportunities to Americans through a combination of grants, loans, rebates and tax
          credits. The IRA includes about two dozen tax provisions that will lower energy bills and
          accelerate the deployment of clean energy, clean vehicles, clean buildings and clean
          manufacturing.
        </p>
      </div>
    </div>
  )
}

export default InformationSection
